import React from 'react';
import { Button, IconButton, CloseIcon } from 'tuui';
import { ChatAgentButtonBase } from 'components/ChatAgent/components/ChatAgentButtonBase/ChatAgentButtonBase';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ChatAgentThemeWrapper } from '../../../../../themes/ChatAgentThemeWrapper';
import { ReactComponent as ChatAgentIcon } from '../chat-agent-icon.svg';
import styles from './recommendationActionBar.module.scss';

export const RecommendationActionBar = ({ onAccept, onClose, message, acceptMessage, chatAgentButtonProps = {} }) => {
    return (
        <ChatAgentThemeWrapper className={styles['container']}>
            <div className={styles['content-container']}>
                <div>
                    <ChatAgentIcon alt="abby-icon" />
                </div>
                {message}
            </div>
            <div className={styles['content-container']}>
                <ChatAgentButtonBase
                    Icon={() => null}
                    className={styles['agent-button-container']}
                    buttonClassName={styles['agent-button']}
                    {...chatAgentButtonProps}
                />
                <Button size={Button.size.sm} onClick={onAccept} className={styles['action-button']}>
                    {acceptMessage || <FormattedMessage id="abby.accept.recommendation" defaultMessage="Accept" />}
                </Button>
                <IconButton size={Button.size.sm} variant={Button.variant.text} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </div>
        </ChatAgentThemeWrapper>
    );
};
